import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router';
import Icon from '@mui/material/Icon';

import { StatsPage, ReportingPage, StatusPage } from '../../pages';

class DashboardPage extends Component {
  render() {
    const { mode } = this.props;

    let Page;
    switch (mode) {
      case 'stats':
        Page = StatsPage;
        break;
      case 'reporting':
        Page = ReportingPage;
        break;
      case 'status':
        Page = StatusPage;
        break;
      default:
        Page = StatsPage;
        break;
    }

    return (
      <div className="dashboard-wrap">
        <div className="dashboard-main-nav">
          <NavLink to="/dashboard" end>
            <Icon>dashboard</Icon>Statistiques
          </NavLink>
          <NavLink to="/dashboard/reporting">
            <Icon>list</Icon>Export Excel
          </NavLink>
          <NavLink to="/dashboard/status">
            <Icon>trending_up</Icon>Statut des demandes
          </NavLink>
        </div>

        <Page />
      </div>
    );
  }
}

DashboardPage.propTypes = {
  mode: PropTypes.string,
};

export default DashboardPage;
